import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PublicCoursesList from '../components/PublicCoursesList/PublicCoursesList';
import { coursesApi } from '../services/api/courses.api';
import axios from '../config/axios';

const CoursesPage = () => {
  const { categoryId } = useParams();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(categoryId || 'all');
  const [loading, setLoading] = useState(true);

  // جلب التصنيفات عند تحميل الصفحة
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // استخدام axios مباشرة لاستدعاء مسار عام للتصنيفات
        const response = await axios.get('/api/categories');
        setCategories(response.data || []);
      } catch (error) {
        console.error('خطأ في جلب التصنيفات:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // تحديث التصنيف المحدد عند تغيير المعرف في الرابط
  useEffect(() => {
    if (categoryId) {
      setSelectedCategory(categoryId);
    }
  }, [categoryId]);

  // تغيير التصنيف المحدد
  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* هيدر جديد للدورات مع تصميم عصري */}
      <div className="relative bg-gradient-to-b from-blue-800 via-blue-700 to-blue-600 dark:from-gray-800 dark:to-gray-900 overflow-hidden">
        {/* زخارف الخلفية */}
        <div className="absolute inset-0 overflow-hidden opacity-10">
          <div className="absolute -top-12 -left-12 w-48 h-48 md:-top-24 md:-left-24 md:w-96 md:h-96 rounded-full bg-white dark:bg-blue-500"></div>
          <div className="absolute top-1/4 left-1/2 w-32 h-32 md:w-64 md:h-64 rounded-full bg-white dark:bg-blue-500"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 md:w-80 md:h-80 rounded-full bg-white dark:bg-blue-500"></div>
        </div>
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-24 pb-12 md:pt-32 md:pb-16">
          <div className="text-center relative z-20">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
              الدورات المتاحة
            </h1>
            <div className="w-24 h-1 bg-yellow-400 dark:bg-yellow-500 rounded-full mb-6 mx-auto"></div>
            <p className="text-lg text-white text-opacity-90 dark:text-gray-200 mb-8 max-w-2xl mx-auto">
              استعرض مجموعة متنوعة من الدورات التدريبية المصممة لتطوير مهاراتك وتعزيز مستقبلك المهني
            </p>
            
            <div className="flex justify-center mb-2">
              <div className="bg-white bg-opacity-20 dark:bg-gray-700 rounded-full px-4 py-1.5 text-sm text-white flex items-center backdrop-blur-sm">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                دعم فني مستمر
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* فلتر التصنيفات - تصميم أنحف */}
          <div className="mb-8">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 mb-3">
              <h3 className="text-lg font-medium text-gray-800 dark:text-white">تصفية حسب التصنيف</h3>
              <div className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                <span className="text-gray-500 dark:text-gray-400 text-xs">{categories.length} تصنيف</span>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-2 mb-2">
              <button 
                onClick={() => setSelectedCategory('all')} 
                className={`py-1.5 px-3 text-sm rounded-full transition-all duration-200 ${selectedCategory === 'all' 
                  ? 'bg-primary-500 text-white dark:bg-primary-600 shadow-sm' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'}`}
              >
                جميع التصنيفات
              </button>
              
              {categories.map((category) => (
                <button 
                  key={category.id} 
                  onClick={() => setSelectedCategory(category.id)}
                  className={`py-1.5 px-3 text-sm rounded-full transition-all duration-200 ${selectedCategory === category.id 
                    ? 'bg-primary-500 text-white dark:bg-primary-600 shadow-sm' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'}`}
                >
                  {category.name}
                </button>
              ))}
            </div>
            
            {categories.length > 10 && (
              <div className="mt-3">
                <select
                  id="category-filter"
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 text-sm"
                >
                  <option value="all">جميع التصنيفات</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          
          {/* عرض قائمة الدورات العامة فقط */}
          <PublicCoursesList categoryId={selectedCategory !== 'all' ? selectedCategory : null} />
        </div>
      </section>
    </div>
  );
};

export default CoursesPage;
